import {
    PieChart,
    Pie,
    Tooltip,
    Cell,
    Legend,
    ResponsiveContainer
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { CustomLegend, PieTooltip, renderCustomizedLabel } from '../utils/graph-utils';
import { facilityColors, legendHeight, legendIconSize, outerRadius, responsiveContainerHeight } from '../constants/graph-constants';

const FacilityPieChart = ({ data, group, type, year, unit }) => {

    // Filter out entries with value 0
    const filteredData = data?.filter(entry => entry.value > 0) || [];
    // sort by alphabetical order
    const sortedFilteredData = filteredData?.slice().sort((a, b) => a?.name?.localeCompare(b?.name))
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {group} {year} Annual {type} Facility Split
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <PieChart>
                    <Tooltip content={<PieTooltip unit={unit} />} />
                    <Legend content={<CustomLegend variant={'facility'} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    <Pie
                        data={sortedFilteredData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={outerRadius}
                        labelLine={false}
                        label={renderCustomizedLabel}
                    >
                        {sortedFilteredData.map((entry, index) => (
                            <Cell key={`cell-${index}`}
                                fill={facilityColors[entry.name] || '#ccc'}
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        </Box>
    )
}

export default FacilityPieChart;